// Portal Status & Type Labels
export const statusLabels = {
  pendente: 'Pendente',
  aprovado_chefia: 'Aprovado Chefia',
  aprovado_rh: 'Aprovado RH',
  aprovado: 'Aprovado',
  rejeitado: 'Rejeitado',
  cancelado: 'Cancelado',
  em_analise: 'Em Análise',
  justificada: 'Justificada',
  injustificada: 'Injustificada',
  agendada: 'Agendada',
  em_curso: 'Em Curso',
  concluida: 'Concluída',
  inscrito: 'Inscrito',
  ativo: 'Ativo',
  inativo: 'Inativo',
  manutencao: 'Manutenção',
  abatido: 'Abatido',
  pago_empresa: 'Pago Empresa',
  pago_colaborador: 'Pago Colaborador',
  contestado: 'Contestado',
  concluido: 'Concluído',
  // Entity Status
  active: 'Ativo',
  inactive: 'Inativo',
  suspended: 'Suspenso',
  terminated: 'Cessado',
  pending: 'Pendente',
  approved: 'Aprovado',
  rejected: 'Rejeitado',
  on_leave: 'De Licença',
  auto_approved: 'Auto-Aprovado',
  auto_rejected: 'Auto-Rejeitado',
  // Conflict Status
  detected: 'Detetado',
  under_review: 'Em Revisão',
  resolved: 'Resolvido',
  dismissed: 'Arquivado',
  mitigated: 'Mitigado'
};

// Risk Level Labels
export const riskLabels = {
  high: 'Alto',
  medium: 'Médio',
  low: 'Baixo',
  critical: 'Crítico',
  none: 'Nenhum'
};

// Conflict Type Labels
export const conflictTypeLabels = {
  ownership: 'Propriedade',
  employment: 'Emprego',
  family: 'Familiar',
  financial: 'Financeiro',
  gift: 'Oferta/Presente',
  other: 'Outro'
};

// Helper function to translate status
export const translateStatus = (status) => statusLabels[status] || status;

// Helper function to translate risk level
export const translateRisk = (risk) => riskLabels[risk] || risk;

export const absenceTypeLabels = {
  doenca: 'Doença',
  acidente: 'Acidente de Trabalho',
  familiar: 'Assistência Familiar',
  pessoal: 'Motivo Pessoal',
  injustificada: 'Injustificada',
  outro: 'Outro'
};

export const fineTypeLabels = {
  velocidade: 'Excesso de Velocidade',
  estacionamento: 'Estacionamento',
  sinal: 'Desrespeito de Sinalização',
  alcool: 'Álcool/Drogas',
  outro: 'Outro'
};

export const benefitTypeLabels = {
  cheque_creche: 'Cheque Creche',
  subsidio_alimentacao: 'Subsídio de Alimentação',
  subsidio_transporte: 'Subsídio de Transporte',
  gym: 'Ginásio',
  outro: 'Outro'
};

export const insuranceTypeLabels = {
  saude: 'Saúde',
  vida: 'Vida',
  acidentes_trabalho: 'Acidentes de Trabalho',
  dental: 'Dental',
  visao: 'Visão'
};

export const relationshipLabels = {
  conjuge: 'Cônjuge',
  filho: 'Filho',
  filha: 'Filha',
  pai: 'Pai',
  mae: 'Mãe',
  outro: 'Outro'
};
